'use strict';

module.exports = function (position, e) {
  // e.preventDefault
  // console.log(e)
  //console.log('inside edit-cell-show:' + position)

  var refToEdit = 'R' + position[0] + 'C' + position[1];

  // console.log(this.opts.cellToEdit)
  // console.log(this.opts.cellToEdit.indexOf(refToEdit) !== -1)

  return this.opts.cellToEdit.indexOf(refToEdit) !== -1;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/edit-cell-show.js